import { IUpdateControleEnergiaUseCase } from "../../../presentation/useCases/update/update_controle_energia_use_case";
import { UpdateControleEnergiaRequestModel, UpdateControleEnergiaResponseModel } from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateControleEnergiaUseCase
 */

export class UpdateControleEnergiaUseCase implements IUpdateControleEnergiaUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async updateControleEnergia(model: UpdateControleEnergiaRequestModel): Promise<UpdateControleEnergiaResponseModel> {
    return await this.repository.updateControleEnergia(model);
  }
}
